import * as React from 'react'
// components
import Footer from '../components/layouts/Footer'
import PrivacyPolicySection from '../components/sections/EUSections/PrivacyPolicy'
import RecruitingHeader from '../components/sections/Alumni/components/RecruitingHeader'
import { HIDE_CONTACT_HEADER_KEY, Themes, useTheme } from '../hooks/useTheme'

const PrivacyPolicyEU = () => {
  const { setTheme } = useTheme()

  React.useEffect(() => {
    setTheme(Themes.LIGHT)
    localStorage.setItem(HIDE_CONTACT_HEADER_KEY, 'true')
  }, [])

  return (
    <>
      <div id='smooth-wrapper'>
        <div id='smooth-content'>
          <div className='podio--light'>
            <PrivacyPolicySection />
            <Footer theme='light' isEu />
          </div>
        </div>
      </div>
      <RecruitingHeader customButtonLabel='Work With Us' />
    </>
  )
}

export default PrivacyPolicyEU
